import * as routeHelpers from "../../lib/routeHelpers";
import * as Sentry from "@sentry/capacitor";
import React, {Component} from "react";
import ErrorModal from "../ErrorModal";

const strings = {
    errorModalBody:
        "An unexpected error occurred and the POS could not recover. If this occurs repeatedly, please contact the help desk. Please click the button below to restart the POS.",
    restartPos: "Restart POS",
};

type Props = {
    children: React.ReactNode;
};

type State = {
    hasError: boolean;
};

class ErrorBoundary extends Component<Props, State> {
    static displayName = "ErrorBoundary";

    state: State = {
        hasError: false,
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    static getDerivedStateFromError(error: any) {
        // Update state so the next render will show the fallback UI.
        return {hasError: true};
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    componentDidCatch(error: Error, info: any) {
        if (import.meta.env.DEV) {
            console.error(error, info);
        }

        Sentry.captureException(error);
    }

    _retry = () => this.setState({hasError: false});

    render() {
        if (this.state.hasError) {
            return (
                <ErrorModal
                    errorMessage={strings.errorModalBody}
                    closeButtonLabel={strings.restartPos}
                    onClose={() => {
                        location.pathname = routeHelpers.menu();
                    }}
                />
            );
        } else {
            return this.props.children;
        }
    }
}

export default ErrorBoundary;
